import { render, staticRenderFns } from "./MissionDetailScienceGraphics.vue?vue&type=template&id=827d2d34"
import script from "./MissionDetailScienceGraphics.vue?vue&type=script&lang=ts"
export * from "./MissionDetailScienceGraphics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports